function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from "react";
import { AdobeTarget } from "./AdobeTarget";
import logger, { LapelError } from "../../logger";
var defaultMapPropsToName = function(_, name) {
    return name;
};
var defaultMapPropsToParameters = function(_, parameters) {
    return parameters;
};
var defaultMapPropsToProfileParameters = function(_, profileParameters) {
    return profileParameters;
};
var withTargetMbox = function(param) {
    var name = param.name, parameters = param.parameters, profileParameters = param.profileParameters, overrideResponseProps = param.overrideResponseProps, _param_mapPropsToName = param.mapPropsToName, mapPropsToName = _param_mapPropsToName === void 0 ? defaultMapPropsToName : _param_mapPropsToName, _param_mapPropsToParameters = param.mapPropsToParameters, mapPropsToParameters = _param_mapPropsToParameters === void 0 ? defaultMapPropsToParameters : _param_mapPropsToParameters, _param_mapPropsToProfileParameters = param.mapPropsToProfileParameters, mapPropsToProfileParameters = _param_mapPropsToProfileParameters === void 0 ? defaultMapPropsToProfileParameters : _param_mapPropsToProfileParameters, _param_forwardRef = param.forwardRef, forwardRef = _param_forwardRef === void 0 ? false : _param_forwardRef, disableFoocMask = param.disableFoocMask;
    if (typeof name !== "string" || name.length === 0) {
        logger.error(new LapelError("Expected parameter `name` to be a string with length > 0"));
        return function(Component) {
            return Component;
        };
    }
    return function(WrappedComponent) {
        var displayName = "withTargetMbox";
        if (forwardRef) {
            var Forwarded = /*#__PURE__*/ React.forwardRef(function(props, ref) {
                var mappedName = useMemo(function() {
                    return mapPropsToName(props, name);
                }, [
                    props
                ]);
                var mappedParameters = useMemo(function() {
                    return mapPropsToParameters(props, parameters);
                }, [
                    props
                ]);
                var mappedProfileParameters = useMemo(function() {
                    return mapPropsToProfileParameters(props, profileParameters);
                }, [
                    props
                ]);
                return(// essentially a wrapper component for the AdobeTarget wrapper
                /*#__PURE__*/ _jsx(AdobeTarget, {
                    name: mappedName,
                    parameters: mappedParameters,
                    profileParameters: mappedProfileParameters,
                    overrideResponseProps: overrideResponseProps,
                    disableFoocMask: disableFoocMask,
                    ref: ref,
                    children: /*#__PURE__*/ _jsx(WrappedComponent, _extends({}, props, {
                        ref: ref
                    }))
                }));
            });
            Forwarded.displayName = displayName;
            return Forwarded;
        }
        var NotForwarded = function(props) {
            var mappedName = useMemo(function() {
                return mapPropsToName(props, name);
            }, [
                props
            ]);
            var mappedParameters = useMemo(function() {
                return mapPropsToParameters(props, parameters);
            }, [
                props
            ]);
            var mappedProfileParameters = useMemo(function() {
                return mapPropsToProfileParameters(props, profileParameters);
            }, [
                props
            ]);
            // essentially a wrapper component for the AdobeTarget wrapper
            return /*#__PURE__*/ _jsx(AdobeTarget, _extends({}, props, {
                name: mappedName,
                parameters: mappedParameters,
                profileParameters: mappedProfileParameters,
                overrideResponseProps: overrideResponseProps,
                disableFoocMask: disableFoocMask,
                children: /*#__PURE__*/ _jsx(WrappedComponent, _extends({}, props))
            }));
        };
        NotForwarded.displayName = displayName;
        return NotForwarded;
    };
};
export { withTargetMbox };

//# sourceMappingURL=WithTargetMbox.js.map